module.exports = __webpack_public_path__ + "img/2-Commrisk-Walkthrough-One-Page-MVP.f8f8886f.png";